import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';
import { v4 as uuidv4 } from 'uuid';

import {
  SIGNALTRANSLATION_ERROR,
  GET_ALL_SIGNALTRANSLATION_DETAILS,
  SIGNALTRANSLATION_IS_LOADING,
  SET_SIGNALTRANSLATION_CURRENT_PAGE,
  SET_SIGNALTRANSLATION_PAGE_FILTER,
  SET_SIGNALTRANSLATION_CHANGE,
  SET_SIGNALTRANSLATION,
  UPDATE_SIGNALTRANSLATION_SAVE_STATUS,
  SET_SIGNALTRANSLATION_RESULT_CHANGE,
  SET_SIGNALTRANSLATION_CONSTANT_CHANGE,
  SET_SIGNALTRANSLATION_COMMENT_CHANGE,
  SIGNALTRANSLATION_VIEW_STATUS,
  SET_SIGNALTRANSLATION_CONST
} from '../constants/index';

import {
  SIGNALTRANSLATION_MANAGEMENT,
  CREATE_SIGNALTRANSLATION,
  UPDATE_SIGNALTRANSLATION,
  DELETE_SIGNALTRANSLATION,
  CREATE_SIGNALTRANSLATION_COMMENT,
  UPDATE_UNIT_SHADOW
} from '../constants/logs';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

export const setSignalTranslationErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setSignalTranslationError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSignalTranslationError(messageCode, false));
  }, 2500);
};

export const setSignalTranslationError = (messageCode, status) => {
  return {
    type: SIGNALTRANSLATION_ERROR,
    payload: {
      data: {
        isOpSuccessful: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const setLoadingStatus = isLoading => ({
  type: SIGNALTRANSLATION_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const getSignalTranslationThunk = (unitSerialNumber, filterObj, widgetCode) => dispatch => {
  dispatch(getSignalTranslation(unitSerialNumber, filterObj, widgetCode));
};

export const getSignalTranslation = (unitSerialNumber, filterObj, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}/device/${unitSerialNumber}/signalTranslations`,
    data: {
      OrgId: Cookies.get(`selectedorganisationid-${envName}`) || 0,
      unitSerialNumber: unitSerialNumber,
      Offset: filterObj.offset,
      Limit: filterObj.limit,
      Filter: filterObj.filter
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setAllSignalTranslationListThunk(retData),
    onFailure: err => setSignalTranslationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllSignalTranslationListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let signalTranslation = (retData && retData.signalTranslations) || [];
  dispatch(setAllSignalTranslationList(messageCode, signalTranslation));
};

export const setAllSignalTranslationList = (messageCode, signalTranslation) => ({
  type: GET_ALL_SIGNALTRANSLATION_DETAILS,
  payload: {
    data: {
      SignalTranslationList: signalTranslation,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false,
      isOpSuccessful: false
    }
  }
});

export const setCurrentPage = currentPage => ({
  type: SET_SIGNALTRANSLATION_CURRENT_PAGE,
  payload: { currentPage }
});

export const setPageFilter = filter => ({
  type: SET_SIGNALTRANSLATION_PAGE_FILTER,
  payload: { filter }
});

export const describeSignalTranslationThunk = (SignalTranslationId, unitSerialNumber, widgetCode) => dispatch => {
  dispatch(describeSignalTranslation(SignalTranslationId, unitSerialNumber, widgetCode));
};

export const describeSignalTranslation = (SignalTranslationId, unitSerialNumber, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}/device/${unitSerialNumber}/signalTranslations`,
    data: {
      SignalTranslationId: SignalTranslationId || undefined,
      OrgId: Cookies.get(`selectedorganisationid-${envName}`) || 0,
      unitSerialNumber: unitSerialNumber
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setSignalTranslationThunk(retData),
    onFailure: err => setSignalTranslationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setSignalTranslationThunk = ({ retData }) => dispatch => {
  let data = (retData.signalTranslation && retData.signalTranslation[0]) || null;
  let describeSignalTranslation = {};
  if (data) {
    describeSignalTranslation = data;
  }

  dispatch(setSignalTranslation(describeSignalTranslation));
};

export const setSignalTranslation = data => ({
  type: SET_SIGNALTRANSLATION,
  payload: {
    SelectedSignalTranslation: data,
    isOpSuccessful: false,
    showBanner: false
  }
});

export const saveSignalTranslationThunk = (SignalTranslation, unitSerialNumber, isOpSuccessful = false, widgetCode) => dispatch => {
  let url = `/device/${unitSerialNumber}/signalTranslations/save`;
  let actionName = SignalTranslation.SignalTranslationId === 0 ? CREATE_SIGNALTRANSLATION : UPDATE_SIGNALTRANSLATION;
  let log = logEntry(SIGNALTRANSLATION_MANAGEMENT, actionName, SignalTranslation);
  dispatch(saveSignalTranslation(SignalTranslation, isOpSuccessful, url, log, widgetCode));
};

export const saveSignalTranslation = (SignalTranslation, isOpSuccessful, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}${url}`,
    method: 'POST',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setSignalTranslationStatusThunk(retData, isOpSuccessful),
    onFailure: err => setSignalTranslationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      SignalTranslation: SignalTranslation,
      log: log
    },
    widgetcode: widgetCode
  });

export const setSignalTranslationStatusThunk = (retData, isOpSuccessful) => dispatch => {
  let messageCode = retData;
  dispatch(setSignalTranslationStatus(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSignalTranslationStatus('', false, isOpSuccessful));
  }, 2500);
};

export const setSignalTranslationStatus = (messageCode, status, isOpSuccessful = true) => ({
  type: UPDATE_SIGNALTRANSLATION_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: isOpSuccessful,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setSignalTranslationChangeThunk = retData => dispatch => {
  dispatch(setSignalTranslationChange(retData));
};

export const setSignalTranslationChange = retData => ({
  type: SET_SIGNALTRANSLATION_CHANGE,
  payload: retData
});

export const setSignalTranslationResultChangeThunk = retData => dispatch => {
  dispatch(setSignalTranslationResultChange(retData));
};

export const setSignalTranslationResultChange = retData => ({
  type: SET_SIGNALTRANSLATION_RESULT_CHANGE,
  payload: retData
});

export const setSignalTranslationConstantThunk = retData => dispatch => {
  dispatch(setSignalTranslationConstantChange(retData));
};

export const setSignalTranslationConstantChange = retData => ({
  type: SET_SIGNALTRANSLATION_CONSTANT_CHANGE,
  payload: retData
});

// export const setSignalTranslationConstantListThunk = retData => dispatch => {
//   dispatch(setSignalTranslationConstantList(retData));
// };

// export const setSignalTranslationConstantList = retData => ({
//   type: SET_SIGNALTRANSLATION_CONSTANT_LIST_CHANGE,
//   payload: retData
// });

export const setViewStatusThunk = status => dispatch => {
  dispatch(setViewStatus(status));
};

export const setViewStatus = status => ({
  type: SIGNALTRANSLATION_VIEW_STATUS,
  payload: { status: status }
});

export const describeSignalTranslationEquationThunk = (SignalTranslationEquationId, SignalTranslationId, modelCategoryId, widgetCode) => dispatch => {
  dispatch(describeSignalTranslationEquation(SignalTranslationEquationId, SignalTranslationId, modelCategoryId, widgetCode));
};

export const describeSignalTranslationEquation = (SignalTranslationEquationId, SignalTranslationId, modelCategoryId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/signalTranslationequations`,
    data: {
      SignalTranslationEquationId: SignalTranslationEquationId || undefined,
      ModelCategoryId:  modelCategoryId
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setSignalTranslationEquationThunk(retData, SignalTranslationId),
    onFailure: err => setSignalTranslationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setSignalTranslationEquationThunk = ({ retData }, SignalTranslationId) => dispatch => {
  let data = (retData.signalTranslationEquation && retData.signalTranslationEquation[0]) || null;
  let SelectedSignalTranslation = {};
  if (data) {
    let SignalTranslationConstants = [];
    if (data.SignalTranslationConstants && data.SignalTranslationConstants.length > 0) {
      data.SignalTranslationConstants.map(eqConst => {
        SignalTranslationConstants.push({
          SignalTranslationComponentConstantId: 0,
          SignalTranslationId: SignalTranslationId,
          SignalTranslationEquationConstantId: eqConst.SignalTranslationEquationConstantId,
          Name: eqConst.Name,
          GuidIdentifier: uuidv4(),
          Description: eqConst.Description,
          isChanged: false,
          ConstantValue: null
        });
      });
    }
    SelectedSignalTranslation = {
      SignalTranslationEquationId: data.SignalTranslationEquationId,
      SignalTranslationEquationName: data.Name,
      SignalTranslationEquationFormula: data.Formula,
      SignalTranslationRequired: false,
      SignalTranslationComponentConstants: SignalTranslationConstants
    };
  }

  dispatch(setSignalTranslationEquation(SelectedSignalTranslation));
};

export const setSignalTranslationEquation = data => ({
  type: SET_SIGNALTRANSLATION_CONST,
  payload: data
});

// SignalTranslation Comments

export const saveSignalTranslationCommentThunk = (SignalTranslation, unitSerialNumber, widgetCode) => dispatch => {
  let url = `/device/${unitSerialNumber}/signalTranslations/comments/save`;
  let actionName = CREATE_SIGNALTRANSLATION_COMMENT;
  let log = logEntry(SIGNALTRANSLATION_MANAGEMENT, actionName, SignalTranslation);
  dispatch(saveSignalTranslationComments(SignalTranslation, url, log, widgetCode));
};

export const saveSignalTranslationComments = (SignalTranslation, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}${url}`,
    method: 'POST',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setSignalTranslationCommentsStatusThunk(retData),
    onFailure: err => setSignalTranslationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      SignalTranslation: SignalTranslation,
      log: log
    },
    widgetcode: widgetCode
  });

export const setSignalTranslationCommentsStatusThunk = ({ message, SignalTranslationComments }) => dispatch => {
  dispatch(setSignalTranslationCommentsStatus(SignalTranslationComments));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSignalTranslationStatus('', false, false));
  }, 2500);
};

export const setSignalTranslationCommentsStatus = retData => ({
  type: SET_SIGNALTRANSLATION_COMMENT_CHANGE,
  payload: { SignalTranslationComments: retData }
});

export const updateUnitShadowThunk = (SignalTranslation, unitSerialNumber, shadowData, isOpSuccessful = false, widgetCode) => dispatch => {
  let url = `/management/modelvariant/updateunitshadow`;
  let actionName = UPDATE_UNIT_SHADOW;
  let log = logEntry(SIGNALTRANSLATION_MANAGEMENT, actionName, shadowData);
  dispatch(updateUnitShadow(SignalTranslation, unitSerialNumber, shadowData, isOpSuccessful, url, log, widgetCode));
};

export const updateUnitShadow = (SignalTranslation, unitSerialNumber, shadowData, isOpSuccessful, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setShadowSuccessStatusThunk(retData, isOpSuccessful, SignalTranslation, unitSerialNumber),
    onFailure: err => setSignalTranslationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      ...shadowData,
      log: log
    },
    widgetcode: widgetCode
  });

export const setShadowSuccessStatusThunk = (retData, isOpSuccessful, SignalTranslation, unitSerialNumber) => dispatch => {
  let messageCode = retData.message;
  dispatch(setSignalTranslationStatus(messageCode, true, isOpSuccessful));
  setTimeout(() => {
    dispatch(saveSignalTranslationThunk(SignalTranslation, unitSerialNumber, false, 'SIGNALTRANSLATION_EDIT'));
  }, 2500);
};

export const deleteSignalTranslationThunk = (SignalTranslationId, unitSerialNumber, isOpSuccessful = false, widgetCode) => dispatch => {
  let url = `/device/${unitSerialNumber}/signalTranslations/delete`;
  let actionName = DELETE_SIGNALTRANSLATION;
  let log = logEntry(SIGNALTRANSLATION_MANAGEMENT, actionName, SignalTranslationId);
  dispatch(deleteSignalTranslation(SignalTranslationId, isOpSuccessful, url, log, widgetCode));
};

export const deleteSignalTranslation = (SignalTranslationId, isOpSuccessful, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}${url}`,
    method: 'POST',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setSignalTranslationStatusThunk(retData, isOpSuccessful),
    onFailure: err => setSignalTranslationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      SignalTranslation: {
        SignalTranslationId: SignalTranslationId
      },
      log: log
    },
    widgetcode: widgetCode
  });
